export default function (e, n) {
  return n = n || {}, new Promise(function (t, r) {
    var s = new XMLHttpRequest(),
        o = [],
        u = [],
        i = {},
        a = function a() {
      return {
        ok: 2 == (s.status / 100 | 0),
        statusText: s.statusText,
        status: s.status,
        url: s.responseURL,
        text: function text() {
          return Promise.resolve(s.responseText);
        },
        json: function json() {
          return Promise.resolve(s.responseText).then(JSON.parse);
        },
        blob: function blob() {
          return Promise.resolve(new Blob([s.response]));
        },
        clone: a,
        headers: {
          keys: function keys() {
            return o;
          },
          entries: function entries() {
            return u;
          },
          get: function get(e) {
            return i[e.toLowerCase()];
          },
          has: function has(e) {
            return e.toLowerCase() in i;
          }
        }
      };
    };

    for (var l in s.open(n.method || "get", e, !0), s.onload = function () {
      s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) {
        o.push(n = n.toLowerCase()), u.push([n, t]), i[n] = i[n] ? i[n] + "," + t : t;
      }), t(a());
    }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers) {
      s.setRequestHeader(l, n.headers[l]);
    }

    s.send(n.body || null);
  });
}